import type { ReactNode } from "react";

import { AssetApiContext } from "./AssetApiContext";

type Props = AssetApiContext & { children: ReactNode };

export const AssetApiProvider = ({ children, ...props }: Props) => {
  return <AssetApiContext.Provider value={props}>{children}</AssetApiContext.Provider>;
};
